<template>
  <div class="account-config-wrapper global-card">
    <bread-crumb />
    <div class="account-config-card">
      <form-card
        ref="formcard2"
        title="修改密码"
        :form-data="formData2"
        :gutter="48"
        style="margin-bottom:100px;"
      >
        <template #pwd_old>
          <a-input
            v-decorator="[
              'pwd_old',
              {
                rules: [{ required: true, message: '请输入旧密码' }],
              },
            ]"
            type="password"
          />
        </template>
        <template #pwd_new>
          <a-input
            v-decorator="[
              'pwd_new',
              {
                rules: [
                  { required: true, message: '请输入新密码' },
                  {
                    validator: validateToNextPassword,
                  },
                ],
              },
            ]"
            type="password"
          />
        </template>
        <template #pwd_new1>
          <a-input
            v-decorator="[
              'pwd_new1',
              {
                rules: [
                  { required: true, message: '再次确认新密码' },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              },
            ]"
            type="password"
            @blur="handleConfirmBlur"
          />
        </template>
      </form-card>
      <form-button
        class="form-card-button"
        cancel-text="返回"
        :btn-is-loading="btnIsLoading"
        @onSubmit="onSubmit"
        @onCancel="onCancel"
      />
    </div>
  </div>
</template>
<script>
import { formData2 } from '../data/index';
export default {
  data() {
    return {
      formData2,
      confirmDirty: false,
      btnIsLoading: false,
      data: {},
    };
  },
  created() {
    // 获取管路员信息
    this.getUserInfo();
  },
  methods: {
    // 获取管路员信息
    async getUserInfo() {
      let result = await this.$http.post('/manager/getCompanyManagerInfo');
      if (result.data.status === 1) {
        let res = result.data.data;
        this.data = {
          real_name: res.real_name,
          phone: res.phone,
        };
      }
    },
    // 修改密码
    onSubmit() {
      this.$refs.formcard2.form.validateFields(async(err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          this.btnIsLoading=true;
          let { pwd_old, pwd_new } = values;
          let result = await this.$http.post('/manager/updateCompanyManager', {
            ...this.data,
            pwd_old,
            pwd_new,
            editFlag: '1',
          });
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
          }
        }
      });

    },
    // 取消修改密码
    onCancel() {
      this.$router.back();
    },
    // 密码
    compareToFirstPassword(rule, value, callback) {
      const form = this.$refs.formcard2.form;
      if (value && value !== form.getFieldValue('pwd_new')) {
        callback('两次输入密码不一致！');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.$refs.formcard2.form;
      if (value && this.confirmDirty) {
        form.validateFields(['pwd_new1'], { force: true });
      }
      callback();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
  },
};
</script>
<style lang="scss" scoped>
.account-config-card{
   background: #fff;
   padding:32px;
  min-height: 360px;
  border-radius: 10px;
  padding-bottom: 0;
  .form-card-button {
    background: #f9f9fc;
    margin: 60px -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
      transform: translateY(10px);
  }
}
</style>
